/**
 * FIN-1052: a match books the document's amount against the bank, so a bank transaction can only
 * settle a document of the same amount, to the cent, until partial settlements exist (FIN-1059).
 * The same rule as the backend's settlementAmountsMatch and the database trigger behind it; a
 * different currency needs a rate and is not compared here.
 */
export function isSettlementAmountMismatch(
  document: { amount: number; currency: string },
  transaction: { amount: number; currency: string },
): boolean {
  if (document.currency.toUpperCase() !== transaction.currency.toUpperCase()) return false;
  return Math.round(Math.abs(document.amount) * 100) !== Math.round(Math.abs(transaction.amount) * 100);
}
